package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.AccountRepository

import dev.zacsweers.metro.Inject

@Inject
class DeleteAccountUseCase(
    private val accountRepository: AccountRepository
) {
    suspend operator fun invoke(id: String): Result<Unit> {
        return accountRepository.deleteAccount(id)
    }
}
